import React from 'react'

const styles = {
  display: 'block',
  margin: '1em 2em',
}

export default function SectionButtons({ displayRetailers }){
  const displayFeatured = (
    typeof LOCATION_EXTRAS === 'object' &&
    Array.isArray( LOCATION_EXTRAS.featuredContent ) &&
    LOCATION_EXTRAS.featuredContent.length > 0
  )
  const showRetailers = Array.isArray(displayRetailers) && displayRetailers.length > 0;
  return(
    <div style={{overflow: 'auto'}}>
      <a href="#creators" className="button--bordered button--lg"
        style={styles}>
        See Food Schedule
      </a>
      { showRetailers &&
        <a href="#retailers" className="button--bordered button--lg"
          style={styles}>
          See Retailers
        </a>
      }
      { displayFeatured &&
        <a href="#featured-content" className="button--bordered button--lg" style={styles} >See Entertainment Lineup</a>
      }
    </div>
  )
}
